import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { CustomItemInfoBoxData } from './custom-item-info-box.model';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-custom-item-info-box',
  templateUrl: './custom-item-info-box.component.html',
  styleUrls: ['./custom-item-info-box.component.scss'],
  standalone: false
})
export class CustomItemInfoBoxComponent implements OnInit {
  @Input() item: CustomItemInfoBoxData;
  @HostBinding('class') styleClasses: string;

  data$: Observable<CustomItemInfoBoxData> = this.component.data$.pipe(
    tap((data) => (this.styleClasses = data?.styleClasses))
  );

  constructor(public component: CmsComponentData<CustomItemInfoBoxData>) { }

  ngOnInit(): void {
  }

}
